import axios from "axios";

export const Api = axios.create({
    baseURL: 'https://email-next-js-patrick.vercel.app/api/',
    headers: {
        'Content-Type': 'application/json'
    }
})

